<template>
    <div>
        <b-container class="center">
            <b-row>
                <b-col>
                    <ImageSlider :images="images" id="home_banner" :only-automatic="true"></ImageSlider>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="home-content">
                    <div class="margin-bottom-lg">
                        <h4 class="caps bold-text">Why Us</h4>
                        <p>
                          For almost 50 years, enviro<strong>SIGNS</strong> has developed <strong>interpretive, educational, identification, wayfinding, historical, and commemorative signage.</strong>
                          Clients are located throughout the United States and beyond.
                          enviro<strong>SIGNS</strong> offers a wealth of experience. Services include content development, illustration, graphic design, fabrication, mountings, and installation.
                        </p>
                    </div>
                    <div class="margin-bottom-lg">
                        <h4 class="caps bold-text">Solutions that Work</h4>
                        <p>
                          Why us? Working together, your project will be a clear success. Our promise has been, and still is, <strong>professional service and quality products.</strong>
                        </p>
                    </div>
                    <div class="caps margin-bottom-lg">
                        <ul class="call-out-list">
                          <li><h6><router-link :to="{ name: 'interpretive' }">Interpretive & Educational Signs</router-link></h6></li>
                          <li><h6><router-link :to="{ name: 'wayfinding' }">Identification & Wayfinding Signs</router-link></h6></li>
                          <li><h6><router-link :to="{ name: 'historical' }">Historical Signs & Markers</router-link></h6></li>
                          <li><h6><router-link :to="{ name: 'commemorative' }">Commemorative Signs & Plaques</router-link></h6></li>
                        </ul>
                    </div>
                  <div class="video-container">
                    <iframe class="video" src="https://www.youtube.com/embed/8nsjxrfwreM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
  import ImageSlider from '../ImageSlider.vue'

  export default {
    name: 'Home',
    components: {
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/home/interpretive-and-educational.jpg'),
          require('@/assets/images/home/identification-and-wayfinding.jpg'),
          require('@/assets/images/home/historical-marker.jpg'),
          require('@/assets/images/home/commemorative-plaque.jpg')
        ],
        type: Array
      }
    }
  }
</script>

<style>
.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  margin-bottom: 20px;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue